<!-- eslint-disable vue/valid-v-model -->
<template>
  <div>
    <div class="contact-info">
      <div
        v-if="hasChanges && shouldShowWarning"
        class="warning-message"
      >
        <inline-svg
          :src="iconWarning"
          class="warning-icon"
        ></inline-svg>
        Changes won’t be saved unless you click Apply.
      </div>
      <div class="inline-row">
        <div
          v-if="formData.isInited && isNeedTitleImage"
          class="wrapper-small"
        >
          <CollectionImageUploader
            :source="getImageSource('collection-titleImage')"
            :submitEventName="submitEventName"
            :submitParams="submitParams"
            :shouldShowWarning="shouldShowWarning"
            @reset-should-show-warning="$emit('resetShouldShowWarning')"
            @handle-add-item-with-changes="handleAddItemWithChanges"
            @handle-remove-item-with-changes="handleRemoveItemWithChanges"
            @handle-item-in-progress="handleItemInProgress"
            @handle-reload-item="handleReloadItem"
          />
        </div>
        <div
          v-if="formData.isInited"
          class="wrapper-small"
        >
          <CollectionImageUploader
            :source="getImageSource('collection-posterImage')"
            :submitEventName="submitEventName"
            :submitParams="submitParams"
            @reset-should-show-warning="$emit('resetShouldShowWarning')"
            @handle-add-item-with-changes="handleAddItemWithChanges"
            @handle-remove-item-with-changes="handleRemoveItemWithChanges"
            @handle-item-in-progress="handleItemInProgress"
            @handle-reload-item="handleReloadItem"
          />
        </div>
        <div
          v-if="formData.isInited"
          class="wrapper-small"
        >
          <CollectionImageUploader
            :source="getImageSource('collection-portraitImage')"
            :submitEventName="submitEventName"
            :submitParams="submitParams"
            @reset-should-show-warning="$emit('resetShouldShowWarning')"
            @handle-add-item-with-changes="handleAddItemWithChanges"
            @handle-remove-item-with-changes="handleRemoveItemWithChanges"
            @handle-item-in-progress="handleItemInProgress"
            @handle-reload-item="handleReloadItem"
          />
        </div>
        <div
          v-if="formData.isInited"
          class="wrapper-small"
        >
          <CollectionImageUploader
            :source="getImageSource('collection-backgroundImage')"
            :submitEventName="submitEventName"
            :submitParams="submitParams"
            @reset-should-show-warning="$emit('resetShouldShowWarning')"
            @handle-add-item-with-changes="handleAddItemWithChanges"
            @handle-remove-item-with-changes="handleRemoveItemWithChanges"
            @handle-item-in-progress="handleItemInProgress"
            @handle-reload-item="handleReloadItem"
          />
        </div>
        <div
          v-if="formData.isInited"
          class="wrapper-small"
        >
          <CollectionImageUploader
            :source="getImageSource('collection-backgroundImage2x3')"
            :submitEventName="submitEventName"
            :submitParams="submitParams"
            @reset-should-show-warning="$emit('resetShouldShowWarning')"
            @handle-add-item-with-changes="handleAddItemWithChanges"
            @handle-remove-item-with-changes="handleRemoveItemWithChanges"
            @handle-item-in-progress="handleItemInProgress"
            @handle-reload-item="handleReloadItem"
          />
        </div>
        <div>
          <div class="localization-btn">
            <Button
              title="Localization"
              classType="primary"
              className="wide-btn"
              :srcSvg="iconLocalization"
              svgClass="folder-localization-icon"
              :eventFunction="handleOpenLocalizationModal"
            />
          </div>
        </div>
      </div>
    </div>
    <CollectionLocalization
      v-if="isLocalizationOpen"
      collectionTab="images"
      :metadata="formData"
      :type="collectionType"
      :onClose="handleCloseLocalizationModal"
    />
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';

import Button from '../common/Button.vue';
import CollectionImageUploader from '../common/PosterImage/CollectionImageUploader.vue';
import CollectionLocalization from '../localization/CollectionLocalization.vue';
import iconFolderLocalization from '../../assets/icons/icon-folder-localization.svg';
import iconWarning from '../../assets/icons/icon-warning-localization.svg';

export default {
  name: 'CollectionImagesForm',
  components: {
    CollectionImageUploader,
    CollectionLocalization,
    Button,
  },
  props: {
    formPrefix: {
      type: String,
      default: 'playlistEditForm',
    },
    collectionType: {
      type: String,
      default: '',
    },
    enabledLanguages: {
      type: Array,
      default: () => [],
    },
    metadata: {
      type: Object,
      default: () => ({}),
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    setHasChanges: {
      type: Function,
      default: () => {},
    },
    shouldShowWarning: {
      type: Boolean,
      default: false,
    },
    submitEventName: {
      type: String,
      required: true,
    },
    submitParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      iconWarning,
      submitEvent: this.submitEventName,
      itemsWithChanges: [],
      iconLocalization: iconFolderLocalization,
      isLocalizationOpen: false,
      formData: {
        id: '',
        isInited: false,
        titleImage: '',
        posterImage: '',
        portraitImage: '',
        backgroundImage: '',
        backgroundImage2x3: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentAccountId',
    ]),
    isNeedTitleImage() {
      return this.collectionType !== 'season';
    },
  },
  watch: {
    itemsWithChanges: {
      handler(newItems) {
        if (newItems.length) {
          this.setHasChanges(true);
        } else {
          this.setHasChanges(false);
        }
      },
      deep: true,
    },
    metadata: {
      handler(newMetadata) {
        this.initFormData(newMetadata);
      },
      deep: true,
    },
  },
  mounted() {
    this.initFormData(this.metadata);
  },
  methods: {
    initFormData(metadata) {
      this.formData.id = metadata.id;
      this.formData.posterImage = metadata.posterImage ? `${metadata.posterImage}?height=360` : '';
      this.formData.portraitImage = metadata.portraitImage ? `${metadata.portraitImage}?height=360` : '';
      this.formData.backgroundImage = metadata.backgroundImage ? `${metadata.backgroundImage}?height=360` : '';
      this.formData.backgroundImage2x3 = metadata.backgroundImage2x3 ? `${metadata.backgroundImage2x3}?height=360` : '';

      if (this.isNeedTitleImage) {
        this.formData.titleImage = metadata.titleImage ? `${metadata.titleImage}?height=360` : '';
      }
      this.formData.isInited = true;
    },
    handleOpenLocalizationModal() {
      this.isLocalizationOpen = true;
    },
    handleCloseLocalizationModal() {
      this.isLocalizationOpen = false;
    },
    handleAddItemWithChanges(id) {
      if (!this.itemsWithChanges.includes(id)) {
        this.itemsWithChanges.push(id);
      }
    },
    handleRemoveItemWithChanges(id) {
      const index = this.itemsWithChanges.indexOf(id);
      if (index !== -1) {
        this.itemsWithChanges.splice(index, 1);
      }
    },
    handleReloadItem() {
      this.$emit('reloadItem');
    },
    handleItemInProgress(item) {
      console.log('Item is in progress', item);
    },
    getImageSource(imageType) {
      const imageProperty = imageType.split('-')[1];
      return {
        url: this.formData[imageProperty],
        name: imageType,
        canEdit: true,
        canDelete: true,
        imageType,
        imageProperty,
      };
    },

    toMoreDetails() {
      this.isFolderOpen = true;
    },
    onCloseLocalizationModal() {
      this.isFolderOpen = false;
    },
  },
};
</script>

<style scoped>
  .person p:last-child {
    background: #383b40;
    margin-top: 10px;
    padding: 15px;
  }

  .poster-title {
    color: #fff;
    font-weight: normal;
    margin-bottom: 10px;
  }

  .wrapper-small {
    margin-bottom: 20px;
  }

  hr {
    border: 0 solid rgba(0, 0, 0, 0.12);
    border-top-width: thin;
    display: block;
    flex: 1 1 0;
    height: 0;
    max-height: 0;
    max-width: 100%;
    transition: inherit;
  }

  .custom-field-wrapper {
    margin-top: 20px;
    overflow-wrap: initial;
    white-space: initial;
  }

  .custom-field-title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .wide-btn {
    width: 100%;
    margin-left: 0;
  }

  .categories-management-wrapper {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .poster-2x3-image{
    height: 400px;
  }

  .genres-management-wrapper {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .warning-message {
    color: #F2C94C;
    gap: 6px;
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border: 1px solid #F2C94C;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    width: fit-content;
    margin-bottom: 30px;
  }
</style>
